import React, { ReactElement } from "react";

import Loader from "shared-components/loader";

import { SubmitButton } from "shared-components/loader-button/styles";

interface Styles {
  margin?: string;
  backgroundColor?: string;
  width?: string;
  height?: string;
}
interface Props {
  submitHandler: (id?) => void;
  isLoading?: boolean;
  disabled?: boolean;
  buttonText: string;
  styles?: Styles;
  className?: string;
}

function LoaderButton({
  submitHandler,
  isLoading,
  disabled,
  buttonText,
  styles,
  className
}: Props): ReactElement {
  const isDisabled = Boolean(isLoading || disabled);
  return (
    <>
      <SubmitButton
        styles={styles as Styles}
        onClick={(id) => submitHandler(id)}
        variant="contained"
        color="primary"
        style={{ pointerEvents: isDisabled ? "none" : "auto" }}
        className={className}
      >
        {isLoading ? <Loader isLoading={isLoading as boolean} /> : buttonText}
      </SubmitButton>
    </>
  );
}

export default LoaderButton;
